import { sensorsTrack } from '@/util/sensorsdata'
import { SENSORS_TRACK } from '@/util/sensorsdata/constant'

// https://pj4w2l1pwuq.sg.larksuite.com/sheets/QY4osqiN1hCfgDt5ZJwltiMRgjc?sheet=UV2IVy

// 入金Step1页浏览(CRM)
const sensorsDepositStep1PageView = () => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_STEP1PAGE_VIEW)
}

// 入金页Back点击(CRM)
const sensorsDepositPageBackClick = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSITPAGE_BACK_CLICK, {
    current_page_name: data.current_page_name,
    account_type: data.account_type,
    account_info: data.account_info,
  })
}

// 入金Step1页账号选择(CRM)
const sensorsDepositStep1PageAccountSelect = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_STEP1PAGE_ACCOUNT_SELECT, {
    account_type: data.account_type,
    account_info: data.account_info,
  })
}

// 入金Step1页金额输入(CRM)
const sensorsDepositStep1PageAmountInput = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_STEP1PAGE_AMOUNT_INPUT, {
    account_platform: data.account_platform,
    account_type: data.account_type,
    account_info: data.account_info,
    is_coupon: data.is_coupon,
    error_alerts: data.error_alerts,
  })
}

// 入金Step1页优惠券使用(CRM)
const sensorsDepositStep1PageVoucherUse = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_STEP1PAGE_VOUCHER_USE, {
    account_platform: data.account_platform,
    account_type: data.account_type,
    account_info: data.account_info,
    is_coupon: data.is_coupon,
    coupon_id: data.coupon_id,
    coupon_name: data.coupon_name,
    coupon_amount: data.coupon_amount,
    coupon_type: data.coupon_type,
  })
}

// 入金Step1页继续点击(CRM)
const sensorsDepositStep1PageContinueClick = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_STEP1PAGE_CONTINUE_CLICK, {
    account_platform: data.account_platform,
    account_type: data.account_type,
    account_info: data.account_info,
    is_coupon: data.is_coupon,
    coupon_id: data.coupon_id,
    coupon_name: data.coupon_name,
    coupon_amount: data.coupon_amount,
    coupon_type: data.coupon_type,
    error_number: data.error_number,
  })
}

// 入金Step2_条款弹窗确认点击
const sensorsDepositStep2IBTPageTermsPopupConfirmClick = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_STEP2_IBTPAGETERMSPOPUP_CONFIRM_CLICK, {
    account_info: data.account_info,
    order_id: data.order_id,
    deposit_method_number: data.deposit_method_number,
    payment_method_number: data.payment_method_number,
    payment_method: data.payment_method ?? null,
  })
}

// 入金未完成KYC弹窗浏览
const sensorsDepositPoPUPAdvancedKYCReqView = () => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_POPUP_ADVANCEDKYCREQ_VIEW)
}

// 入金未完成进阶KYC弹窗点击
const sensorsDepositPoPUPAdvancedKYCReqClick = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_POPUP_ADVANCEDKYCREQ_CLICK, {
    account_info: data.account_info,
    order_id: data.order_id,
    deposit_method_number: data.deposit_method_number,
    payment_method_number: data.payment_method_number,
    button_name: data.button_name,
  })
}

// 入金方式不足最小额度弹窗浏览
const sensorsDepositPopUpMinDepositUnmetView = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_POPUP_MINDEPOSITUNMET_VIEW, {
    account_info: data.account_info,
    deposit_method_number: data.deposit_method_number,
  })
}

// 入金方式不足最小额度弹窗点击
const sensorsDepositPopUpMinDepositUnmetClick = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_POPUP_MINDEPOSITUNMET_CLICK, {
    account_info: data.account_info,
    deposit_method_number: data.deposit_method_number,
    payment_method_number: data.payment_method_number,
    button_name: data.button_name,
  })
}

// 入金方式不支援该优惠券弹窗浏览
const sensorsDepositPopUpCouponUnusableView = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_POPUP_COUPONUNUSABLE_VIEW, {
    account_info: data.account_info,
    deposit_method_number: data.deposit_method_number,
    payment_method_number: data.payment_method_number,
    coupon_id: data.coupon_id,
    coupon_name: data.coupon_name,
    coupon_amount: data.coupon_amount,
    coupon_type: data.coupon_type,
  })
}

// 入金方式不支援该优惠券弹窗浏览
const sensorsDepositPopUpCouponUnusableClick = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_POPUP_COUPONUNUSABLE_CLICK, {
    account_info: data.account_info,
    deposit_method_number: data.deposit_method_number,
    payment_method_number: data.payment_method_number,
    button_name: data.button_name,
    coupon_id: data.coupon_id,
    coupon_name: data.coupon_name,
    coupon_amount: data.coupon_amount,
    coupon_type: data.coupon_type,
  })
}

// 入金结果页浏览
const sensorsDepositResultPageView = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_RESULTPAGE_VIEW, {
    account_info: data.account_info,
    order_id: data.order_id,
    order_status: data.order_status,
    is_success: data.is_success,
    deposit_method_number: data.deposit_method_number,
    payment_method_number: data.payment_method_number,
  })
}

// 入金结果页重新尝试按钮点击
const sensorsDepositRetryClick = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_RETRY_CLICK, {
    account_info: data.account_info,
    order_id: data.order_id,
    deposit_method_number: data.deposit_method_number,
    payment_method_number: data.payment_method_number,
    fail_reason: data.fail_reason,
  })
}

// 入金结果页回到首页按钮点击
const sensorsDepositBackToHomePageClick = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_BACKTOHOMEPAGE_CLICK, {
    account_info: data.account_info,
    order_id: data.order_id,
    deposit_method_number: data.deposit_method_number,
    payment_method_number: data.payment_method_number,
    fail_reason: data.fail_reason,
  })
}

// 出金Step1页浏览
const sensorsWithdrawalStep1PageView = () => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.WITHDRAWAL_STEP1PAGE_VIEW)
}

// 出金页返回点击
const sensorsWithdrawPageBackClick = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.WITHDRAWALPAGE_BACK_CLICK, {
    current_page_name: data.current_page_name,
    account_platform: data.account_platform,
    account_type: data.account_type,
    account_info: data.account_info,
  })
}

// 出金Step1页账号选择
const sensorsWithdrawalStep1PageAccountClick = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.WITHDRAWAL_STEP1PAGE_ACCOUNT_CLICK, {
    account_platform: data.account_platform,
    account_type: data.account_type,
    account_info: data.account_info,
  })
}

// 出金Step1页输入金额
const sensorsWithdrawalStep1PageAmountInput = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.WITHDRAWAL_STEP1PAGE_AMOUNT_INPUT, {
    account_platform: data.account_platform,
    account_type: data.account_type,
    account_info: data.account_info,
    error_alerts: data.error_alerts,
  })
}

// 出金Step1页继续点击
const sensorsWithdrawalStep1PageContinueClick = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.WITHDRAWAL_STEP1PAGE_CONTINUE_CLICK, {
    account_platform: data.account_platform,
    account_type: data.account_type,
    account_info: data.account_info,
    error_number: data.error_number,
  })
}

// 出金Step2页浏览
const sensorsWithdrawalStep2View = () => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.WITHDRAWAL_STEP2_VIEW)
}

// 出金Step2页入金详情页前端载入完成
const sensorsWithdrawalStep2DetailPapeView = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.WITHDRAWAL_STEP2_DETAILPAGE_VIEW, {
    account_info: data.account_info,
  })
}

// 出金Step2页出金详情页提交点击
const sensorsWithdrawalStep2DetailPageSubmitClick = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.WITHDRAWAL_STEP2_DETAILPAGE_SUBMIT_CLICK, {
    account_info: data.account_info,
    withdrawal_method_number: data.withdrawal_method_number,
    withdrawal_channel_number: data.withdrawal_channel_number,
  })
}

// 出金Step2页用户未设定2FA弹窗点击
const sensorsWithdrawalPopUpStep2YetToHave2FAClick = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.WITHDRAWALPOPUP_STEP2_YETTOHAVE2FA_CLICK, {
    account_info: data.account_info,
    withdrawal_method_number: data.withdrawal_method_number,
    withdrawal_channel_number: data.withdrawal_channel_number,
    button_name: data.button_name,
  })
}

// 出金Step2页用户已设定2FA弹窗点击
const sensorsWithdrawalPopUpStep2AlreadyHave2FAClick = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.WITHDRAWALPOPUP_STEP2_ALREADYHAVE2FA_CLICK, {
    account_info: data.account_info,
    withdrawal_method_number: data.withdrawal_method_number,
    withdrawal_channel_number: data.withdrawal_channel_number,
    button_name: data.button_name,
    field_name: data.field_name,
  })
}

// 出金Step2页出金存款卡设定
const sensorsWithdrawalStep2ArchiveCardSetting = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.WITHDRAWAL_STEP2_ARCHIVECARD_SETTING, {
    account_info: data.account_info,
    withdrawal_method_number: data.withdrawal_method_number,
    button_name: data.button_name,
    field_name: data.field_name,
  })
}

// 出金Step2页出金银行账户设定
const sensorsWithdrawalStep2SelectBankAccountSetting = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.WITHDRAWAL_STEP2_SELECTBANKACCOUNT_SETTING, {
    account_info: data.account_info,
    withdrawal_method_number: data.withdrawal_method_number,
    withdrawal_channel_number: data.withdrawal_channel_number,
    button_name: data.button_name,
    field_name: data.field_name,
  })
}

// 出金暂时锁定弹窗浏览
const sensorsWithdrawalPopUpWithdrawalOnHoldView = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.WITHDRAWALPOPUP_WITHDRAWALONHOLD_VIEW, {
    account_info: data.account_info,
    withdrawal_method_number: data.withdrawal_method_number,
    withdrawal_channel_number: data.withdrawal_channel_number,
  })
}

// 出金暂时锁定弹窗点击
const sensorsWithdrawalPopUpWithdrawalOnHoldClick = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.WITHDRAWALPOPUP_WITHDRAWALONHOLD_CLICK, {
    account_info: data.account_info,
    withdrawal_method_number: data.withdrawal_method_number,
    withdrawal_channel_number: data.withdrawal_channel_number,
    button_name: data.button_name,
  })
}

// 出金结果页浏览
const sensorsWithdrawalResultPageView = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.WITHDRAWAL_RESULTPAGE_VIEW, {
    account_info: data.account_info,
    withdrawal_method_number: data.withdrawal_method_number,
    withdrawal_channel_number: data.withdrawal_channel_number,
  })
}

// 出金结果页回到首页按钮点击
const sensorsWithdrawalBackToHomePageClick = data => {
  sensorsTrack(SENSORS_TRACK.EVENT_NAME.WITHDRAWAL_BACKTOHOMEPAGE_CLICK, {
    account_info: data.account_info,
    withdrawal_method_number: data.withdrawal_method_number,
    withdrawal_channel_number: data.withdrawal_channel_number,
    fail_reason: data.fail_reason,
  })
}

export {
  sensorsDepositStep1PageView,
  sensorsDepositPageBackClick,
  sensorsDepositStep1PageAccountSelect,
  sensorsDepositStep1PageAmountInput,
  sensorsDepositStep1PageVoucherUse,
  sensorsDepositStep1PageContinueClick,
  sensorsDepositStep2IBTPageTermsPopupConfirmClick,
  sensorsDepositPoPUPAdvancedKYCReqView,
  sensorsDepositPoPUPAdvancedKYCReqClick,
  sensorsDepositPopUpMinDepositUnmetView,
  sensorsDepositPopUpMinDepositUnmetClick,
  sensorsDepositPopUpCouponUnusableView,
  sensorsDepositPopUpCouponUnusableClick,
  sensorsDepositResultPageView,
  sensorsDepositRetryClick,
  sensorsDepositBackToHomePageClick,
  sensorsWithdrawalStep1PageView,
  sensorsWithdrawPageBackClick,
  sensorsWithdrawalStep1PageAccountClick,
  sensorsWithdrawalStep1PageAmountInput,
  sensorsWithdrawalStep1PageContinueClick,
  sensorsWithdrawalStep2View,
  sensorsWithdrawalStep2DetailPapeView,
  sensorsWithdrawalStep2DetailPageSubmitClick,
  sensorsWithdrawalPopUpStep2YetToHave2FAClick,
  sensorsWithdrawalPopUpStep2AlreadyHave2FAClick,
  sensorsWithdrawalStep2ArchiveCardSetting,
  sensorsWithdrawalStep2SelectBankAccountSetting,
  sensorsWithdrawalPopUpWithdrawalOnHoldView,
  sensorsWithdrawalPopUpWithdrawalOnHoldClick,
  sensorsWithdrawalResultPageView,
  sensorsWithdrawalBackToHomePageClick,
}
